import { motion } from "motion/react";

// Minimal ACG decorative flourishes — kept very restrained.
// (All 2233 mascots removed per design feedback.)

// Floating star / sparkle decoration.
export function Sparkle({
  size = 16,
  color = "#FFD166",
  delay = 0,
  className = "",
}: {
  size?: number;
  color?: string;
  delay?: number;
  className?: string;
}) {
  return (
    <motion.svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      initial={{ opacity: 0, scale: 0 }}
      animate={{
        opacity: [0, 1, 1, 0],
        scale: [0, 1, 1, 0.6],
        rotate: [0, 90, 180, 270],
      }}
      transition={{
        duration: 2.5,
        repeat: Infinity,
        delay,
        ease: "easeInOut",
      }}
    >
      <path
        d="M12 0 L14 10 L24 12 L14 14 L12 24 L10 14 L0 12 L10 10 Z"
        fill={color}
      />
    </motion.svg>
  );
}